import React from "react";

import BasePadding from "@cayuse/shared-react.components.base-padding";
import VerticalSpacing from "@cayuse/shared-react.components.vertical-spacing";

import OverviewLineItemsList from "../OverviewLineItemsList";
import styles from "./styles.css";

const OverviewMainView = () => {
	return (
		<div className={styles.budgetSettings}>
			<BasePadding>
				<VerticalSpacing>
					<OverviewLineItemsList />
				</VerticalSpacing>
			</BasePadding>
		</div>
	);
};

export default OverviewMainView;
